import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  ChangePasswordRequest,
  SeguridadService,
} from '../../service/seguridad.service';
import { UtilService } from '../../service/util.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {
  loading = false;
  statusLoadFailed = false;
  passwordConfigured: boolean | null = null;
  form = this.formBuilder.nonNullable.group({
    currentPassword: ['', Validators.required],
    newPassword: ['', [Validators.required, Validators.minLength(8)]],
    newPasswordConfirm: ['', [Validators.required, Validators.minLength(8)]],
  });

  constructor(
    private formBuilder: FormBuilder,
    private seguridadService: SeguridadService,
    private utilService: UtilService,
    private router: Router
  ) {}

  ngOnInit() {
    this.seguridadService.getPasswordStatus().subscribe({
      next: response => this.passwordConfigured = response.passwordConfigured,
      error: () => {
        this.statusLoadFailed = true;
        this.utilService.alertWarnning(
          'No se pudo consultar la configuración de contraseña'
        );
      },
    });
  }

  submit() {
    if (!this.passwordConfigured || this.form.invalid) {
      this.utilService.alertWarnning('Todos los campos son obligatorios');
      return;
    }
    const request: ChangePasswordRequest = this.form.getRawValue();
    if (request.newPassword !== request.newPasswordConfirm) {
      this.utilService.alertWarnning('Las contraseñas nuevas no coinciden');
      return;
    }

    this.loading = true;
    this.seguridadService.changePassword(request).subscribe({
      next: () => {
        this.loading = false;
        this.form.reset();
        this.utilService.alertSuccess('Contraseña actualizada correctamente');
      },
      error: (error) => {
        this.loading = false;
        this.utilService.alertWarnning(
          error?.error?.message || 'No se pudo actualizar la contraseña'
        );
      },
    });
  }

  back() {
    this.router.navigate([
      this.router.url.startsWith('/gestor') ? '/gestor/inicio' : '/mi-cuenta',
    ]);
  }
}
